import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'
import HistoryAmbReport from './HistoryAmbReport'

/** หน้า ประวัติการเล่นพนัน */
const HistoryGamblePage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()
  return <HistoryAmbReport mode="settled" />
}

export default HistoryGamblePage
